const component = (place, types) => {
  const parts = place?.address_components || [];
  return types.map(type => parts.find(part => part.types?.includes(type))?.long_name).find(Boolean) || "";
};

export const placeSelectionFromGoogle = place => {
  const geometry = place?.geometry?.location;
  const latitude = geometry && Number(geometry.lat());
  const longitude = geometry && Number(geometry.lng());
  const city = component(place, ["locality", "administrative_area_level_2", "postal_town"]);
  const state = component(place, ["administrative_area_level_1"]);

  if (!place?.place_id || !place?.name || !place?.formatted_address || !Number.isFinite(latitude) || !Number.isFinite(longitude)) return null;
  return {
    name: place.name,
    location: place.formatted_address,
    city,
    state,
    latitude,
    longitude,
    maps: place.url || `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`,
    gplace_id: place.place_id,
    telefono: place.formatted_phone_number || place.international_phone_number || "",
    selectedPlace: true,
  };
};

export const locationMetadata = place => ({
  gplace_id: place.gplace_id || null,
  telefono: place.telefono || null,
  city: place.city || null,
  state: place.state || null,
  latitude: Number.isFinite(place.latitude) ? place.latitude : null,
  longitude: Number.isFinite(place.longitude) ? place.longitude : null,
});
